module.exports = __webpack_public_path__ + "static/media/smitha.b1032e1a.jpg";